import {useQuery} from '@tanstack/react-query';
import {queryKeys} from '../react-query/constant';
import getPatientInfo from '../api/patientInfo';

export const usePatientInfo = (id) => {
  return useQuery([queryKeys.patientInfo, id], () => getPatientInfo(id), {
    refetchOnWindowFocus: false,
    enabled: !!id,
    staleTime: 5 * 60 * 1000, //5min
    cacheTime: 10 * 60 * 1000, //10min
    onError: (error) => console.log(error),
  });
};
